import React, {useState} from 'react';
import {Link} from 'react-router-dom';

import {
    Box,
    Button,
    Card,
    CardContent, Container,
    FormControl,
    Grid, InputAdornment,
    InputLabel,
    MenuItem, Paper,
    Select, Tab, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tabs,
    TextField
} from "@mui/material";
import {useSelector} from "react-redux";

import Loading from "../../components/Common/Loading";
import {
    useCreateAudienceMutation,
    useGetAllAudiencesQuery,
    useUpdateAudienceMutation
} from "../../core/api/audience-api";
import {isAdmin} from "../../core/utils/commonUtils";
import {
    useCreateCampaignMutation,
    useGetAllCampaignsQuery,
    useUpdateCampaignMutation
} from "../../core/api/campaign-api";
import CreateCampaignModal from "./CreateCampaignPage";
import CampaignsList from "./CampaignsList";

export default function Campaigns() {

    const [status, setStatus] = useState("");


    const statusTabs = [
        { value: "", label: "ALL" },
        { value: "DRAFT", label: "DRAFT" },
        { value: "SCHEDULED", label: "SCHEDULED" },
        { value: "ACTIVE", label: "ACTIVE" },
        { value: "COMPLETED", label: "COMPLETED" },
        { value: "CANCELLED", label: "CANCELLED" },
    ];

    const handleTabChange = (event, newValue) => {
        setStatus(newValue);
    };

    const [campaignDialog, setCampaignDialog] = useState(false)

    const handleCreateCampaign = () => {
        setCampaignDialog(true)
    }

    return <>
        <Box>

            <Box display="flex" justifyContent="space-between" alignItems="center">
                <h1>Campaigns</h1>

                <Button variant="contained"
                    to={"/createCampaign"}
                    component={Link}
                >
                    Create new Campaign
                </Button>
            </Box>

            <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 3 }}>
                <Tabs
                    value={status}
                    onChange={handleTabChange}
                    aria-label="status"
                >
                    {statusTabs.map((tab) => (
                        <Tab
                            key={tab.value}
                            label={tab.label}
                            value={tab.value}
                        />
                    ))}
                </Tabs>
            </Box>

            <CampaignsList status={status} />

        </Box>

    </>
}